import { SalesSummaryMetric } from 'interfaces/sales-summary.interface';

export const SALES_SUMMARY_METRICS: SalesSummaryMetric[] = [
  { id: 'totalSales', label: 'Total Sales', className: '!text-red1' },
  { id: 'revenue', label: 'Revenue', className: '!text-orange' },
  { id: 'expenses', label: 'Expenses', className: '!text-green4' },
  { id: 'growth', label: 'Growth', className: '!text-green5' },
];
